import { render, staticRenderFns } from "./BookingEnquiry.vue?vue&type=template&id=2431d4c2&scoped=true&"
import script from "./BookingEnquiry.vue?vue&type=script&lang=js&"
export * from "./BookingEnquiry.vue?vue&type=script&lang=js&"
import style0 from "./BookingEnquiry.vue?vue&type=style&index=0&id=2431d4c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2431d4c2",
  null
  
)

export default component.exports